export default __webpack_public_path__ + "static/media/25092703.fc08276c.jpg";